import { render, staticRenderFns } from "./Client-carousel.vue?vue&type=template&id=37b8f6d2&scoped=true&"
import script from "./Client-carousel.vue?vue&type=script&lang=js&"
export * from "./Client-carousel.vue?vue&type=script&lang=js&"
import style0 from "./Client-carousel.vue?vue&type=style&index=0&id=37b8f6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8f6d2",
  null
  
)

export default component.exports